import { IPagination } from 'app/types/common';

export interface IRefundsState {
  readonly refundsById?: any;
  readonly refundIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectRefundLoading?: boolean;
  readonly showAddRefund?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationRefundIds?: string[];
  readonly currentRefundId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IRefundsSelector
  extends IRefundsState {
  readonly currentRefund?: any;
  readonly currentFormRefund?: any;
  readonly refundsFilteredByOrganisationInSelectFormat?: any;
  readonly refundsByTagAndIdInSelectFormat?: any;
  readonly refundsByIdInSelectFormat?: any;
  readonly refundsFilteredByCompetitionInSelectFormat?: any;
  readonly refundsFilteredByIdInSelectFormat?: any;
}

export enum RefundsActionTypes {
  GET_ALL_REFUNDS_REQUESTED = 'redux-app/refunds/GET_ALL_REFUNDS_REQUESTED',
  GET_ALL_REFUNDS_PENDING = 'redux-app/refunds/GET_ALL_REFUNDS_PENDING',
  GET_ALL_REFUNDS_SUCCESS = 'redux-app/refunds/GET_ALL_REFUNDS_SUCCESS',
  GET_ALL_REFUNDS_FAIL = 'redux-app/refunds/GET_ALL_REFUNDS_FAIL',
  GET_REFUND_REQUESTED = 'redux-app/refunds/GET_REFUND_REQUESTED',
  GET_REFUND_PENDING = 'redux-app/refunds/GET_REFUND_PENDING',
  GET_REFUND_SUCCESS = 'redux-app/refunds/GET_REFUND_SUCCESS',
  GET_REFUND_FAIL = 'redux-app/refunds/GET_REFUND_FAIL',
  UPDATE_REFUND_REQUESTED = 'redux-app/refunds/UPDATE_REFUND_REQUESTED',
  UPDATE_REFUND_PENDING = 'redux-app/refunds/UPDATE_REFUND_PENDING',
  UPDATE_REFUND_SUCCESS = 'redux-app/refunds/UPDATE_REFUND_SUCCESS',
  UPDATE_REFUND_FAIL = 'redux-app/refunds/UPDATE_REFUND_FAIL',
  CREATE_REFUND_REQUESTED = 'redux-app/refunds/CREATE_REFUND_REQUESTED',
  CREATE_REFUND_PENDING = 'redux-app/refunds/CREATE_REFUND_PENDING',
  CREATE_REFUND_SUCCESS = 'redux-app/refunds/CREATE_REFUND_SUCCESS',
  CREATE_REFUND_FAIL = 'redux-app/refunds/CREATE_REFUND_FAIL',
  DELETE_REFUND_REQUESTED = 'redux-app/refunds/DELETE_REFUND_REQUESTED',
  DELETE_REFUND_PENDING = 'redux-app/refunds/DELETE_REFUND_PENDING',
  DELETE_REFUND_SUCCESS = 'redux-app/refunds/DELETE_REFUND_SUCCESS',
  DELETE_REFUND_FAIL = 'redux-app/refunds/DELETE_REFUND_FAIL',
  SELECT_REFUND_REQUESTED = 'redux-app/refunds/SELECT_REFUND_REQUESTED',
}

export default null;
